$(document).on("click", ".infocardAction", function(event: JQuery.Event) {
  event.preventDefault();

  // Cache the clicked element.
  const $clickedElement: JQuery = $(this);

  // Check if the clicked element has an 'open' attribute.
  if ($clickedElement.hasClass("open")) {
      // Extract the value of the 'open' attribute.
      const originalText: string = $clickedElement.attr("closeMsg") || "";

      // Cache the parent card and its content.
      const $card: JQuery = $clickedElement.parent();
      const $cardContent: JQuery = $card.find(".infocardContent");

      // Hide all other infocards.
      $(".infocard").addClass("d-none").removeClass("h-fc");

      // Display the current card and its content.
      $card.removeClass("d-none").addClass("h-fc");
      $cardContent.removeClass("d-none");

      // Modify the clicked element attributes and text.
      $clickedElement.text(originalText);
      $clickedElement.removeClass("open").addClass("close");
  } else if ($clickedElement.hasClass("close")) {
      // Extract the value of the 'close' attribute.
      const originalText: string = $clickedElement.attr("openMsg") || "";

      // Cache the parent card and its content.
      const $card: JQuery = $clickedElement.parent();
      const $cardContent: JQuery = $card.find(".infocardContent");

      // Display all infocards.
      $(".infocard").removeClass("d-none");

      // Hide the current card content.
      $cardContent.addClass("d-none");

      // Reset the card's display properties.
      $card.removeClass("h-fc");

      // Modify the clicked element attributes and text.
      $clickedElement.text(originalText);
      $clickedElement.removeClass("close").addClass("open");
  }
});

export function lsModal_view(screen: string,modal:JQuery<HTMLElement>) {
  let screens:Record<string,JQuery<HTMLElement>> = {
    "login": modal.find("[loginMainContent]"),
    "signup": modal.find("[signupMainContent]"),
    "forgotpassword": modal.find("[forgotPasswordContent]")
  };
  for (const key in screens) {
    if (key == screen) {
      screens[key].removeClass("d-none");
    } else if (!screens[key].hasClass("d-none")) {
      screens[key].addClass("d-none");
    };
  };
};